import { FunctionComponent, memo } from "react";
import { Form, Formik } from "formik";
import Qs from "qs";
import { SubmitOnChange } from "@edgetier/components";
import SelectInteractionType from "components-for/filters/select-interaction-type";
import { IFormValues, IProps } from "./anomalies-form-filters.types";
import { getInitialValues } from "./anomalies-form-filters.utilities";
import { useHistory, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments, faDatabase } from "@fortawesome/pro-solid-svg-icons";
import SelectModel from "components-for/filters/select-model";
import { ModelType } from "@edgetier/watchtower-types";
import "./anomalies-form-filters.scss";

/**
 * The anomalies filters that are displayed in a form.
 */
const AnomaliesFormFilters: FunctionComponent<IProps> = () => {
    const history = useHistory();
    const { search } = useLocation();
    const searchParameters = Qs.parse(search, { ignoreQueryPrefix: true });

    /**
     * Add to the URL any filters selected by the user.
     * @param values The filters submitted in the form.
     */
    const onSubmit = (values: IFormValues) => {
        history.push({
            search: Qs.stringify({ ...searchParameters, ...values }, { arrayFormat: "repeat", skipNulls: true }),
        });
    };

    return (
        <Formik<IFormValues> initialValues={getInitialValues(searchParameters)} onSubmit={onSubmit}>
            <Form className="anomalies-form-filters" name="anomalies-form-filters">
                <div className="field field-inline">
                    <div className="field-inline__icon">
                        <FontAwesomeIcon icon={faComments} />
                    </div>
                    <SelectInteractionType isClearable />
                </div>

                <div className="field field-inline">
                    <div className="field-inline__icon">
                        <FontAwesomeIcon icon={faDatabase} />
                    </div>
                    <SelectModel
                        queryParameters={{ modelType: [ModelType.Metric, ModelType.Text] }}
                        isClearable
                        isSingleSelect
                    />
                </div>
                <SubmitOnChange />
            </Form>
        </Formik>
    );
};

export default memo(AnomaliesFormFilters);
